export enum forumUserTypes {
    FETCH_FORUM_USER_BY_ID = 'FETCH_FORUM_USER_BY_ID',
    SET_FORUM_USER = 'SET_FORUM_USER',
}
